/**
 * Query keys for workflow invites.
 *
 * The list HOOK that used to live here is gone. Unopened invites are no longer fetched
 * separately: the sessions endpoint folds them into its own results as Not Started rows,
 * so the "Invited · Not started" view and its second request no longer exist.
 *
 * The keys stay because the two invite MUTATIONS (send, resend) still invalidate them —
 * cheap, and it keeps them correct for anything that reads invites directly later.
 */
export const inviteKeys = {
  all: ['workflowInvites'] as const,
  list: (params: Record<string, unknown>) => ['workflowInvites', 'list', params] as const,
};
